export default __webpack_public_path__ + "static/media/hamster.1f648be0.webp";